import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
// These regular expressions are all used for form validation
export class RegexService {
  constructor() { }

  // used for FirstName, LastName, City
  get HumanName() {
    return "^[a-zA-Z0-9-.'\\s]*$"; // only alphanumic and space . '
  }
  get HName() {
    return "^[a-zA-Z\\s]*$"; // only alpha and space . '

  }
  get Email() {
    return '^.+@.+\\..+$'; // contains @ and . with text surrounding
  }

  get Phone() {
    return '^[6-9][0-9]{9}$'; // max 20 chars, numbers and -
  }

  get Percentage() {
    return '^(100([\.][0]{1,})?$|[0-9]{1,2}([\.][0-9]{1,})?)$'
  }

  get Date() {
    return '^[0-9]{2}-[0-9]{2}-[0-9]{4}$'; // mm-dd-yyyy, all numbers
  }

  get Aadhar() {
    return '[0-9]{12}';
  }
  get chequeNumber() {
    return '[0-9]{6}';
  }
  // getZip(countryCode = 'US') {
  //   switch (countryCode) {
  //     case 'CA':
  //       return '^[A-Za-z]\\d[A-Za-z][ -]?\\d[A-Za-z]\\d$';
  //     case 'US':
  //       return '^[0-9]{5}$'; // US zip - five numbers
  //   }
  // }
  get Pan() {
    return '^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$'
  }
  get Ifsc() {
    return '^[A-Za-z]{4}[a-zA-Z0-9]{7}$'
  }

  get Pincode() {
    return '^[0-9]{6}$'
  }
  get CityName() {
    return '^([a-zA-Z]+|[a-zA-Z]+\s[a-zA-Z]+)$'
  }
  get Name() {
    return '^[a-zA-Z]+(?:-[a-zA-Z]+)*$'
  }
  get MultilingualAlphabet() {
    return /^([^0-9]*)$/
  }

  get OrganizationName() {
    return '^([a-zA-Z]+ ?)*$'
  }

  get OTP() {
    return '^[1-9][0-9]{5}$'
  }


  get UserName() {
    return "^[a-zA-Z-.'\\s]*$"; // only alphanumic and space . '
    // return "^[a-zA-Z0-9!@#$&()\\- `.+,/\"]*$"
  }
  // get EmailId(){
  //   return "^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
  // }
get NamewithAnd(){
  return "^[ A-Za-z0-9_@./#&+-]*$"
}
get NameandSpace(){
  return "/^[a-zA-Z ]*$/"
}
  get FullName() {
    return "^[A-Z][a-zA-Z]{3,}(?: [A-Z][a-zA-Z]*){0,2}$";
  }




  get Chasisregx() {
    return "^[a-zA-Z0-9]*$"; //number and alphabates only
  }

  get RegistrationNo(){
    return "/[^% 0-9a-zA-Z0-9]*/g";
  }


  get GstNo(){
    return '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$'
  }
get alphaNumeric(){
 return '^[a-zA-Z0-9_.-]*$'
}
get onlyAlphabets(){
  return '[a-zA-Z][a-zA-Z ]+'
}




  NumberKeyEvent(event:any){
    var ASCIICode = event.which ? event.which : event.keyCode;
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) return false;
    return true;
  }
  NumberKeyEvent1(event:any){
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 48 && charCode <= 57)) {
      // if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return true;
  }
  else{
  return false;
  }
  }
  AlphaNumericSpaceHyphenOnly2(event: any) : Boolean{

    //alphabets A-Z a-z and space numbers slash and hyphen
        const charCode = (event.which) ? event.which : event.keyCode;
          if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || (charCode == 32) ||
          (charCode >= 48 && charCode <= 57) || (charCode == 47) || (charCode == 45)) {
          return true;
        }
        else{
        return false;
        }
      }


Alpha(event: any) : Boolean{

  //alphabets A-Z a-z and space numbers slash and hyphen
      const charCode = (event.which) ? event.which : event.keyCode;
        if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) ) {
        return true;
      }
      else{
      return false;
      }
    }
    loadScript() {
      var isFound = false;
      var scripts = document.getElementsByTagName("script")
      for (var i = 0; i < scripts.length; ++i) {
          if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("checkout")) {
              isFound = true;
          }
      }

      if (!isFound) {
          var dynamicScripts = ["https://checkout.razorpay.com/v1/checkout.js"];

          for (var i = 0; i < dynamicScripts.length; i++) {
              let node = document.createElement('script');
              node.src = dynamicScripts [i];
              node.type = 'text/javascript';
              node.async = false;
              node.charset = 'utf-8';
              document.getElementsByTagName('head')[0].appendChild(node);
          }

      }
    }

    containsSpecialChars(str) {
      const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/;
      return specialChars.test(str);
    }
}
